<template>
  <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="container">
                    <div class="row mt-5">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Bidang Sarana dan Prasarana</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a></li>
                                        <li class="breadcrumb-item active" aria-current="page">Bidang Sarana dan Prasarana</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <section class="blog_area mt-5">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <p v-html="uraian"></p>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </section>
        </main>
</template>

<script>

    export default {

        data() {
            return {
                list_data: [],
                page_first: 1,
                page_last: 0,
                cari_value: "",
                uraian: "",
                kategori: "Bidang Sarana dan Prasarana Penyuluhan Pertanian",
            }
        },
        methods: {
        getView: function() {
            fetch(this.$store.state.url.URL_UNIT_KERJA + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body : JSON.stringify({
                    kategori: this.kategori,
                }),
            })
            .then(res => res.json())
            .then(res_data => {
                var data = res_data[0];
                this.uraian = data.uraian;

                // console.log(res_data)
            });
        },
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getView();
        }
    };
</script>
